



























































import { Component, Vue, Ref } from 'vue-property-decorator'
import { loginByOpenID, getState } from '@/request/apis/UserRequest'
import { QQUserDetail } from '@/types/QQ'
import APP_CONFIG from '../../../config.json'
import MailLoginForm from '@/components/register_login/MailLoginForm.vue'
import LoginOptions from '@/components/register_login/LoginOptions.vue'
import PageWithHeaderFooter from '@/components/common/PageWithHeaderFooter.vue'
import WechatLogin from '@/components/common/WechatLogin.vue'

@Component({
  components: { PageWithHeaderFooter, LoginOptions, MailLoginForm, WechatLogin }
})
export default class Login extends Vue {
  WechatLoginAppId = APP_CONFIG.Wechat_LOGIN_APP_ID
  WechatLoginProxy = `${APP_CONFIG.Wechat_LOGIN_REDIRECT_URL}`

  private selectLoginOption: string = ''
  private wechatState: string = ''
  /**
   * 切换登录方式
   * @param type 登录方式, qq | wechat | email
   */
  private async loginOptionChangeHandler (type: string) {
    this.selectLoginOption = type
    if (type === 'wechat') {
      this.wechatState = await getState(null).start()
    }
  }

  /**
   * QQ login success
   * @param userInfo { QQUserDetail } QQ user detail
   */
  protected async loginSuccessHandler (userInfo: QQUserDetail): Promise<void> {
    console.log(userInfo)
    const loginRequest = loginByOpenID(document.body, userInfo.openId)
    try {
      const loginResult = await loginRequest.start()
      // 登录成功之后保存 token, 后续请求都要带上这个 token
      await this.$store.dispatch('updateToken', loginResult.token)
      // 登录成功之后保存用户信息
      await this.$store.dispatch('updateUserInfo', { username: userInfo.nickname, avatar: userInfo.avatar })
      // @ts-ignore
      await this.$router.push({ path: this.$route.query.redirect || `/${this.$route.params.lang}` })
    } catch (e) {
      console.log(e)
    }
  }

  /**
   * QQ login error
   * @param errMsg { string } 错误信息
   */
  protected loginErrorHandler (errMsg: string): void {
    this.$message && this.$message(errMsg)
  }
}
